import { Col, Row, Form, Input, Button, Card, Steps } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import Slider from "react-slick";
import { IoLocationSharp, IoShieldOutline } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { IoMdClock } from "react-icons/io";
import { AiOutlineCar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
const description = 'This is a description.';

const { Meta } = Card;
const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent14 = () => {
  const navigate = useNavigate();
  const settings = {
    dots: false,
    // arrows:false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <section className="laptop:py-16 py-8">
        <Row justify={"center"}>
          <Col xxl={18} xl={20} lg={20} md={22} xs={24}>
            <Row justify="center" className="items-center">
              <Col xxl={12} md={12} sm={20} xs={20}>
                <h3 className="font-goldman text-white xldesktop:text-[30px] laptop:text-[28px] laptop:leading-[40px] leading-[28px]">
                  What We Provide Is the Luxury Transport and Most Comfortable
                  Experience
                </h3>
                <p className="text-[#666666] text-[15px] antialiased  md:py-0 py-3">
                  Offering luxurious transportation and ensuring the utmost
                  comfort for our clients is our priority. Whether it’s a
                  chauffeured limousine service, a private jet charter, or a VIP
                  travel experience, we go above and beyond to provide
                  unparalleled luxury and convenience. Our vehicles are
                  meticulously maintained, our staff is highly trained, and our
                  services are tailored to exceed expectations. From the moment
                  you book with us until you reach your destination, expect
                  nothing less than a seamless, indulgent journey.
                </p>
              </Col>
              <Col xxl={12} md={12} sm={20} xs={20}>
                <div className="relative">
                  <div className="web-card max-w-[500px]  p-[30px] ms-auto mr-5 h-[415px] res-h">
                    <div className="flex justify-between items-center">
                      <span>
                        <h3 className="font-goldman text-white md:text-[40px]">
                          Luxury Car
                        </h3>
                        <h5 className="font-goldman text-white md:text-[22px]">
                          Chauffeur Service
                        </h5>
                      </span>
                      <span className="web-btn flex w-10 h-10 items-center justify-center cursor-pointer" style={{transform: "rotate(315deg)"}}>
                        <FaArrowRightLong />
                      </span>
                    </div>
                  </div>
                  <div className="about-new-car">
                    <img
                      src={ImageUrl("carimg.png")}
                      alt="vector"
                      className=""
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="py-5 home-modals-box">
        <Row justify={"center"}>
          <Col xxl={18} xl={20} lg={20} md={22} xs={24}>
            <Row justify="center" className="items-center py-6">
              <Col xxl={24} md={24} sm={24} xs={24}>
                <div className="about-step-box relative">
                  <div className="anim">
                    <img
                      src={ImageUrl("provideBest.png")}
                      alt="vector"
                      className="ml-auto"
                    />
                  </div>
                  <div className="about-step">
                    <h3 className="font-goldman text-white text-[40px] leading-[75px]">
                      How We Works?
                    </h3>
                    <Steps
                      direction="vertical"
                      current={0}
                      items={[
                        {
                          title: "Create Your Route",
                          description:"Enter your pickup & dropoff locations or the number of hours you wish to book a car and driver for."
                        },
                        {
                          title: "Choose Vehicle For You",
                          description:"On the day of your ride, you will receive two email and SMS updates – one informing you."
                        },
                        {
                          title: "Enjoy The Journey",
                          description:"After your ride has taken place, we would appreciate it if you could rate your car."
                        },
                      ]}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            {/* <Row justify="center" className="items-center py-6">
              <Col lg={14}>
                <div className="anim">
                  <img
                    src={ImageUrl("provideBest.png")}
                    alt="vector"
                    className=""
                  />
                </div>
              </Col>
            </Row> */}
          </Col>
        </Row>
      </section>

      <section className="py-5 home-modals-box">
        <h3 className="font-goldman text-white text-[40px] leading-[75px] text-center res-40">
          Make Your Trip With Us
        </h3>
        <Row justify={"center"}>
          <Col lg={18}>
            <Row className="">
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    <IoShieldOutline />
                  </div>
                  <h4 className="font-goldman text-white">Safety First</h4>
                  <p>
                    We follow the highest security standards to make your
                    journey comfortable and secure.
                  </p>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    {/* <MdEmail /> */}
                    <img
                      src={ImageUrl("ticket-car.png")}
                      alt="vector"
                      className=""
                    />
                  </div>
                  <h4 className="font-goldman text-white">
                    Prices With No Surprises
                  </h4>
                  <p>
                    Our upfront quotes ensure there are no hidden or unexpected
                    charges, so you enjoy your trip carefree.
                  </p>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    <AiOutlineCar />
                  </div>
                  <h4 className="font-goldman text-white">
                    Private Travel Solutions
                  </h4>
                  <p>
                    With us, you get to travel your way to any meeting, special
                    event, or even to a different city.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent14;
